<template>
  <div class="dashboard">
    <div class="container">
      <State 
        v-if="showdashboard"
        @outlinerkits="outlinerkits"
        @switchOrder="switchOrder"
        @inventoryShow="inventoryShow"
        @fbaInventoryShow="fbaInventoryShow"
        :steps="step"
      ></State>
      <Breadcrumb :breadcrumbs="breadcrumbItems" />
      <Filters
        v-if="showouterfilter === 'no'"
        @showAddAdminModal="showAddAdminModal"
        @showAddLabOperatorModal="showAddLabOperatorModal"
        @showTestKitModal="showTestKitModal"
        @showHolidaysModal="showHolidaysModal"
        @showComponent="showComponent"
        @viewoutlinerfilters="viewoutlinerfilters"
        @outlinerkits="outlinerkits"
        @showAddInv="showAddInv"
        :steps="step"
      ></Filters>
      <OuterlineFilter
        v-if="showouterfilter === 'yes'"
        @showAddAdminModal="showAddAdminModal"
        @showAddLabOperatorModal="showAddLabOperatorModal"
        @showTestKitModal="showTestKitModal"
        @showComponent="showComponent"
        :steps="step"
      >
      </OuterlineFilter>
      <EditTestkit v-if="showEdit"  @closeModal="closeEditing"></EditTestkit>
      <AddInventory v-if="addInv"  @closeModal="closeAddInv"></AddInventory>
      <EditInventory v-if="editInv.show" :item="editInv.item" @closeModal="closeEditInv"></EditInventory>
      
      <Modal v-if="modal" @closeModal="closeModal"></Modal>
      <AddTestKit v-if="show" @closeModal="closeKitModal"></AddTestKit>
      <AddHoliday
        v-if="showHoliday"
        @closeModal="closeHolidayModal"
      ></AddHoliday>
      <Kits
        @showModal="showModal"
        v-if="component === 0"
        @showComment="showComment"
        @showCommentArchive="showCommentArchive"
        @confurmDelKit="confurmDelKit"
        @confurmArvKit="confurmArvKit"
        @confirmUnArvKit="confirmUnArvKit"
        @confirmCusLogin="confirmCusLogin"
        @confirmEraseKit="confirmEraseKit"
        @editKit="editKit"
      ></Kits>
      <InventoryKits    
        @showModal="showModal"
        v-if="component === 15"
        @showComment="showComment"
        @showCommentArchive="showCommentArchive"
        @confurmDelKit="confurmDelKit"
        @confurmArvKit="confurmArvKit"
        @confirmUnArvKit="confirmUnArvKit"
        @confirmCusLogin="confirmCusLogin"
        @confirmEraseKit="confirmEraseKit"
        @editKit="editKit">
      </InventoryKits>
      <Admin
        v-if="component === 1"
        @showAdminInfo="showAdminInfo"
        @confurmDelAdmin="confurmDelAdmin"
      ></Admin>
      <LabOperator
        v-if="component === 2"
        @showLabOperatorInfo="showLabOperatorInfo"
        @confirmDelLabOps="confirmDelLabOps"
      ></LabOperator>
      <Analytics
        @showModal="showModal"
        v-if="component === 3"
        @showComment="showComment"
      ></Analytics>
      <PendingKits
        @showModal="showModal"
        v-if="component === 4"
        @showComment="showComment"
        @showCommentArchive="showCommentArchive"
        @confurmDelKit="confurmDelKit"
        @confurmArvKit="confurmArvKit"
        @confirmUnArvKit="confirmUnArvKit"
        :steps="step"
      ></PendingKits>
      <QRcode v-if="component === 6"></QRcode>
      <KitUrlGenerator v-if="component === 7"></KitUrlGenerator>
      <Customers
        @userkits="userkits"
        @editCusKit = "editCusKit"
        @confirmCusLogin="confirmCusLogin"
        v-if="component === 8"
      ></Customers>
      <EditCustomer
        v-if="showCusEdit"
        @closeCusEdit = "closeCusEdit"
        :currentCus = "currentCus"
      >
      </EditCustomer>
      <FederalHolidays
        v-if="component === 9"
        @confirmDelHoliday="confirmDelHoliday"
      ></FederalHolidays>
      <UserLogs v-if="component === 21"></UserLogs>
      <ProblematicKits v-if="component === 23" @showModal="showModal" @showComment="showComment" @showCommentArchive="showCommentArchive" @confurmDelKit="confurmDelKit" @confurmArvKit="confurmArvKit" @confirmUnArvKit="confirmUnArvKit" @confirmCusLogin="confirmCusLogin" @confirmEraseKit="confirmEraseKit" @editKit="editKit"></ProblematicKits>
      <WooOrders v-if="component === 32"></WooOrders>
      <NewOrdersCSV v-if="component === 12"></NewOrdersCSV>
      <NewCSVReader v-if="component === 13"></NewCSVReader>
      <AddWsCSV v-if="component === 19"></AddWsCSV>
      <WSList v-if="component === 20"></WSList>
      <AnalyticsDashboard v-if="component === 11" ></AnalyticsDashboard>
      <InvButtonCard  v-if="component === 14"  @editAddInv="editAddInv"></InvButtonCard>
      <AddAdminModal
        v-if="showAddAdmin"
        @closeAdminModal="closeAdminModal"
      ></AddAdminModal>
      <AddLabOperatorModal
        v-if="showAddLabOperator"
        @closeLabOperatorModal="closeLabOperatorModal"
      ></AddLabOperatorModal>
      <ConfurmModal
        v-if="showConfurmModal"
        :AdminInfo="AdminInfo"
        @closeConfurmModal="closeConfurmModal"
      ></ConfurmModal>
      <ConfirmModalOps
        v-if="showConfirmModalOps"
        :LabOperatorInfo="LabOperatorInfo"
        @closeConfirmModalOps="closeConfirmModalOps"
      ></ConfirmModalOps>
      <ConfurmKitRemove
        v-if="showConfurmModalKit"
        :KitInfo="KitInfo"
        @closeConfurmModalKit="closeConfurmModalKit"
      ></ConfurmKitRemove>
      <ConfirmHoliday
        v-if="showConfirmDelHoliday"
        :holidayInfo="holidayInfo"
        @closeConfirmDelHoliday="closeConfirmDelHoliday"
      ></ConfirmHoliday>
      <ConfirmKitArchive
        v-if="showConfrimArcModalKit"
        :KitInfo="KitInfo"
        @closeAchriveConfurmModal="closeAchriveConfurmModal"
      ></ConfirmKitArchive>
      <ConfrimEraseModalKit
        v-if="showConfrimEraseModalKit"
        :KitInfo="KitInfo"
        @closeConfrimEraseModalKit="closeConfrimEraseModalKit"
      ></ConfrimEraseModalKit>
      <ConfirmKitUnArchive
        v-if="showConfrimUnArcModalKit"
        :KitInfo="KitInfo"
        @closeUnAchriveConfurmModal="closeUnAchriveConfurmModal"
      ></ConfirmKitUnArchive>
      <ConfirmLoginToCustomer
        v-if="showConfrimCusLogin"
        :customerInfo="customerInfo"
        @closeCusLogin="closeCusLogin"
      ></ConfirmLoginToCustomer>
      <EditAdminInfo
        v-if="adminInfoModal"
        :AdminInfo="AdminInfo"
        @closeAdminInfoModal="closeAdminInfoModal"
      ></EditAdminInfo>
      <EditLabOperatorInfo
        v-if="labOperatorInfoModal"
        :LabOperatorInfo="LabOperatorInfo"
        @closeLabOperatorInfoModal="closeLabOperatorInfoModal"
      ></EditLabOperatorInfo>
      <CommentOnHold
        v-if="showCommentModal"
        @closeConfurmHoldTxt="closeConfurmHoldTxt"
        :txtOnHold="txtOnHold"
      ></CommentOnHold>
      <CommentArchive
        v-if="showCommentModalArchive"
        @closeConfurmArchiveTxt="closeConfurmArchiveTxt"
        :txtArchive="txtArchive"
        :KitInfo="KitInfo"
      ></CommentArchive>
      <FbaInventoryTable v-if="showFbaInv"   @closeInv="closeInv"></FbaInventoryTable>
      <AmazonFba v-if="component === 16" ></AmazonFba>
      <Sales v-if="component === 17" ></Sales>
      <InventoryTable v-if="showInv"   @closeInv="closeInv"></InventoryTable>
      <Alert v-if="errorMes"></Alert>
      <Loader v-if="loader"></Loader>
      <div class="row info-row" v-if="currentUser">
        <info-block
          v-for="(item, key) in currentUser.testkits"
          :key="key"
          :info="checknull(item)"
          :title="item.title ? `${item.title}` : `Project ${key + 1}`"
          :kitId="item.kit_id"
          :userProfile="currentUser"
          :status="item.status"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import State from "./dashboard/State";
import Filters from "./dashboard/Filters";
import Kits from "./dashboard/Kits";
import Modal from "./dashboard/Modal";
import AddTestKit from "./dashboard/AddTestKit";
import AddHoliday from "./dashboard/AddHoliday";
import Admin from "./dashboard/Admin";
import AddAdminModal from "./dashboard/AddAdminModal";
import EditAdminInfo from "./dashboard/EditeAdminInfo";
import EditLabOperatorInfo from "./dashboard/EditLabOperatorInfo";
import ConfurmModal from "./dashboard/ConfurmModal";
import ConfirmModalOps from "./dashboard/ConfirmModalOps";
import ConfirmKitArchive from "./dashboard/ConfirmKitArchive";
import ConfirmHoliday from "./dashboard/ConfirmHoliday";
import ConfurmKitRemove from "./dashboard/ConfurmKitRemove";
import CommentOnHold from "./dashboard/CommentOnHold";
import LabOperator from "./dashboard/LabOperator";
import Analytics from "./dashboard/Analytics";
import AddLabOperatorModal from "./dashboard/AddLabOperatorModal";
import PendingKits from "./dashboard/PendingKits";
import QRcode from "./dashboard/QRcode";
import OuterlineFilter from "./dashboard/OuterlineFilter";
import CommentArchive from "./dashboard/CommentArchive";
import Customers from "./dashboard/Customers.vue";
// import InfoBlock from "./infoBlock/InfoBlock";
import KitUrlGenerator from "./dashboard/kitUrlGenerator/KitUrlGenerator";
import FederalHolidays from "./dashboard/FederalHolidays";
import ConfirmLoginToCustomer from "./dashboard/modal/ConfirmLoginToCustomer";
import ConfrimEraseModalKit from "./dashboard/modal/ConfrimEraseModalKit";
import ConfirmKitUnArchive from "./dashboard/modal/ConfirmKitUnArchive"
import InventoryTable from "./dashboard/modal/InventoryTable";
import FbaInventoryTable from "./dashboard/modal/FbaInventoryTable";
import AmazonFba from "./dashboard/AmazonFba";
import Sales from "./dashboard/Sales";
import EditTestkit from "./dashboard/modal/EditTestkit";
import WooOrders from "./dashboard/WooOrders";
import Loader from './Loader.vue';
import Alert from "./dashboard/modal/Alert"
import NewOrdersCSV from "./dashboard/NewOrdersCSV";
import NewCSVReader from "./dashboard/NewCSVReader";
import AddWsCSV from "./dashboard/AddWsCSV";
import EditCustomer from "./dashboard/modal/editCustomer";
import InventoryManagement from "./dashboard/InventoryManagement";
import AddInventory from "./dashboard/modal/AddInventory";
import EditInventory from "./dashboard/modal/EditInventory";
import InvButtonCard from "./dashboard/cards/InvButtonCard";
import Breadcrumb from "./dashboard/breadcrumb/Breadcrumb";
import InventoryKits from "./dashboard/InventoryKits";
import UserLogs from "./dashboard/UserLogs";
import WSList  from "./dashboard/WSList.vue";
import AnalyticsDashboard  from "./WooAnalytics/AnalyticsDashboard.vue";
import ProblematicKits from "./dashboard/ProblematicKits";
export default {
  name: "Dashboard",
  props: ["steps"],
  data() {
    return {
      CommentModal: null,
      modal: false,
      show: false,
      showHoliday: false,
      showAddAdmin: false,
      showAddLabOperator: false,
      component: 0,
      adminInfoModal: false,
      labOperatorInfoModal: false,
      AdminInfo: null,
      LabOperatorInfo: null,
      showConfurmModal: false,
      showConfirmModalOps: false,
      showConfurmModalKit: false,
      showConfirmDelHoliday: false,
      showConfrimArcModalKit: false,
      showConfrimEraseModalKit: false,
      showConfrimUnArcModalKit: false,
      showConfrimCusLogin: false,
      showCusEdit: false,
      customerInfo: false,
      KitInfo: null,
      holidayInfo: null,
      showCommentModal: false,
      showCommentModalArchive: false,
      txtOnHold: "",
      txtArchive: "",
      step:0,
      currentUser:null,
      showouterfilter: 'no',
      showfilter: 'yes',
      loader : false,
      errorMes : false,
      showEdit : false,
      addInv : false,
      editInv:{
          show:false,
          item:null
      },
      kitData:"",
      currentCus: null,
      showInv:false,
      showFbaInv:false,
      breadcrumbItems:[ { text: 'Test Kits', link: "/dashboard" },
      { text: 'Management'}],
      showdashboard:true
    };
  },
  computed: {
    ...mapGetters(["getLoader","getErrorMessage","getViewoutlinerfilters","getComponentNum"]),
  },
  watch : {
    getLoader: {
      immediate: true,
      handler(val) {
        this.loader = val;
      }
    },
    getErrorMessage(val){
      this.errorMes = val
    },
    getComponentNum(val) {
      this.component = val;
      // When landing on the Inventory Dashboard, ensure a clean default view:
      // hide the State header, hide the Filters bar, and set the correct breadcrumbs.
      if (val === 14) {
        this.showdashboard = false;
        this.showouterfilter = 'hidden';
        this.breadcrumbItems = [
          { text: 'Inventory', link: '/dashboard' },
          { text: 'Items' }
        ];
      } else {
        if (this.showouterfilter === 'hidden') {
          this.showouterfilter = 'no';
          this.showfilter = 'yes';
        }
      }
    },
    getViewoutlinerfilters(value){
      if (value.showfilter) {
        this.showouterfilter = "no";
        this.showfilter = "yes";
      } else {
        this.showouterfilter = "yes";
        this.showfilter = "no";
      }
    },
  },
  methods: {
    ...mapActions([
      "getAdminInfoList",
      "setAdminPginationPage",
      "getLabOperatorInfoList",
      "setAnalyticsHead",
      "getPendingInfoList",
      "getAverageReportResultList",
      "setComponentNum"
    ]),
    inventoryShow(obj){
      if(!this.loader) {
       this.showInv = obj;
      }
    },
    fbaInventoryShow(obj){
      if(!this.loader) {
       this.showFbaInv = obj;
      }
    },
    closeInv(boolean){
      this.showInv = boolean;
      this.showFbaInv = boolean;
    },
    breadcrums(obj){
      this.breadcrumbItems = obj.path;
      this.showdashboard = obj.show;
    },
    viewoutlinerfilters(showfilter, value) {
      if (showfilter.showfilter.value === 0) {
        this.showouterfilter = "no";
        this.showfilter = "yes";
      } else {
        this.showouterfilter = "yes";
        this.showfilter = "no";
      }
    },
    editCusKit(obj){
      this.showCusEdit = obj.show;
      this.currentCus = obj.item;
    },
    closeCusEdit(obj){
      this.showCusEdit = obj;
    },
    outlinerkits(val) {
      this.step = val;
    },
    switchOrder(val) {
      this.component = val.steps;
      this.step = val;
    },
    showComment(obj) {
      this.showCommentModal = obj.show;
      this.txtOnHold = obj;
    },
    showCommentArchive(obj) {
      this.showCommentModalArchive = obj.show;
      this.txtArchive = obj;
    },
    closeConfurmArchiveTxt(boolean) {
      this.showCommentModalArchive = boolean;
    },
    userkits(obj) {
      // console.log(obj);
    },
    closeConfurmHoldTxt(boolean) {
      this.showCommentModal = boolean;
    },
    showAdminInfo(obj) {
      this.adminInfoModal = obj.show;
      this.AdminInfo = obj;
    },
    showLabOperatorInfo(obj) {
      this.labOperatorInfoModal = obj.show;
      this.LabOperatorInfo = obj;
    },
    showModal(boolean) {
      this.modal = boolean;
    },
    showTestKitModal(boolean) {
      this.show = boolean;
    },
    showHolidaysModal(boolean) {
      this.showHoliday = boolean;
    },
    showComponent(step) {
      this.component = step;
      this.setComponentNum(step);
    },
    handleTitle(obj) {
      if (obj && obj.value !== undefined) {
        const step = obj.value;
        this.component = step;
        this.setComponentNum(step);
        if (step === 14) {
          this.showdashboard = false;
          this.showouterfilter = 'hidden';
          this.breadcrumbItems = [
            { text: 'Inventory', link: '/dashboard' },
            { text: 'Items' }
          ];
        } else {
          if (this.showouterfilter === 'hidden') {
            this.showouterfilter = 'no';
            this.showfilter = 'yes';
          }
        }
      }
    },
    closeModal(boolean) {
      this.modal = boolean;
    },
    editKit(boolean) {
      this.showEdit = boolean.show;
    },
    closeEditing(boolean) {
      this.showEdit = boolean;
    },
    showAddInv(boolean) {
      this.addInv = boolean;
    },
    editAddInv (data) {
      this.editInv.show = true;
      this.editInv.item = data.item.item;
    },
    closeEditInv(boolean) {
      this.editInv.show =  boolean;
    },
    closeAddInv(boolean) {
      this.addInv = boolean;
    },
    closeAdminModal(boolean) {
      this.showAddAdmin = boolean;
    },
    closeLabOperatorModal(boolean) {
      this.showAddLabOperator = boolean;
    },
    closeKitModal(boolean) {
      this.show = boolean;
    },
    closeHolidayModal(boolean) {
      this.showHoliday = boolean;
    },
    showAddAdminModal(boolean) {
      this.showAddAdmin = boolean;
    },
    showAddLabOperatorModal(boolean) {
      this.showAddLabOperator = boolean;
    },
    closeAdminInfoModal(boolean) {
      this.adminInfoModal = boolean;
    },
    closeLabOperatorInfoModal(boolean) {
      this.labOperatorInfoModal = boolean;
    },
    confurmDelAdmin(obj) {
      this.showConfurmModal = obj.show;
      this.AdminInfo = obj;
    },
    confirmDelLabOps(obj) {
      this.showConfirmModalOps = obj.show;
      this.LabOperatorInfo = obj;
    },
    closeConfurmModal(boolean) {
      this.showConfurmModal = boolean;
    },
    closeConfirmModalOps(boolean) {
      this.showConfirmModalOps = boolean;
    },
    confurmDelKit(obj) {
      this.showConfurmModalKit = obj.show;
      this.KitInfo = obj;
    },
    confirmDelHoliday(obj) {
      this.showConfirmDelHoliday = obj.show;
      this.holidayInfo = obj;
    },
    confurmArvKit(obj) {
      this.showConfrimArcModalKit = obj.show;
      this.KitInfo = obj;
    },
    confirmEraseKit(obj) {
      this.showConfrimEraseModalKit = obj.show;
      this.KitInfo = obj;
    },
    confirmUnArvKit(obj) {
      this.showConfrimUnArcModalKit = obj.show;
      this.KitInfo = obj;
    },
    confirmCusLogin(obj) {
      this.showConfrimCusLogin = obj.show;
      this.customerInfo = obj.user;
    },
    closeCusLogin(boolean) {
      this.showConfrimCusLogin = boolean;
    },
    closeConfurmModalKit(boolean) {
      this.showConfurmModalKit = boolean;
    },
    closeAchriveConfurmModal(boolean) {
      this.showConfrimArcModalKit = boolean;
    },
    closeConfrimEraseModalKit(boolean) {
      this.showConfrimEraseModalKit = boolean;
    },
    closeUnAchriveConfurmModal(boolean) {
      this.showConfrimUnArcModalKit = boolean;
    },
    closeConfirmDelHoliday(boolean) {
      this.showConfirmDelHoliday = boolean;
    }
  },
  components: {
    AddAdminModal,
    ConfurmKitRemove,
    EditAdminInfo,
    State,
    Filters,
    Kits,
    CommentOnHold,
    Admin,
    Modal,
    AddTestKit,
    AddHoliday,
    ConfurmModal,
    LabOperator,
    Analytics,
    AddLabOperatorModal,
    EditLabOperatorInfo,
    ConfirmModalOps,
    PendingKits,
    QRcode,
    ConfirmKitArchive,
    OuterlineFilter,
    CommentArchive,
    Customers,
    KitUrlGenerator,
    FederalHolidays,
    ConfirmHoliday,
    ConfirmLoginToCustomer,
    ConfrimEraseModalKit,
    ConfirmKitUnArchive,
    EditTestkit,
    AddInventory,
    EditInventory,
    WooOrders,
    Loader,
    Alert,
    NewOrdersCSV,
    NewCSVReader,
    AddWsCSV,
    InventoryManagement,
    InvButtonCard,
    EditCustomer,
    InventoryTable,
    FbaInventoryTable,
    AmazonFba,
    Sales,
    Breadcrumb,
    InventoryKits,
    UserLogs,
    WSList,
    AnalyticsDashboard,
    ProblematicKits
  },
  mounted() {
    this.$eventBus.$on("breadcrums", this.breadcrums);
    this.$eventBus.$on("title", this.handleTitle);
    if (this.getComponentNum !== undefined && this.getComponentNum !== null) {
      this.component = this.getComponentNum;
      // When landing on the Inventory Dashboard (component 14), apply a clean default view:
      // hide the State header, hide the Filters bar, and set the correct breadcrumbs.
      if (this.getComponentNum === 14) {
        this.showdashboard = false;
        this.showouterfilter = 'hidden';
        this.breadcrumbItems = [
          { text: 'Inventory', link: '/dashboard' },
          { text: 'Items' }
        ];
      }
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("breadcrums", this.breadcrums);
    this.$eventBus.$off("title", this.handleTitle);
  }
};
</script>

<style scoped>
.dashboard {
  padding: 110px 0 10px 0;
  background-color: #e6ecf0;
  max-width: 100%;
  width: 100vw;
  min-height: 95vh;
  position: relative;
}
@media print {
  .dashboard {
    min-height: 10vh;
  }
}
</style>
